import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-header-content',
  templateUrl: './header-content.component.html',
  styleUrls: ['./header-content.component.scss'],
  imports: [NgIf]
})
export class HeaderContentComponent {
  @Input() title = '';
  @Input() text = '';
  @Input() backgroundImage = '';
  @Input() minHeight = '300px';
  @Input() contentColumnClass = 'col-lg-10 col-md-11';
  @Input() textClass = 'text-white mt-0 mb-5';
}
